import React, { useEffect } from "react";
import { GridStack } from "gridstack";
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";
import Resource from "./Resource";
import DMSHeader from "../../DMSHeader/DMSHeader";
import CreateResourceRegForm from "./CreateResourceRegForm";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

const CreateResource = () => {
  const { t, i18n } = useTranslation();
  const { state } = useLocation();
  const inEdit = state?.edit;

  console.log(inEdit, "inedit");

  useEffect(() => {
    GridStack.init();
  }, []);
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 0,
      component: (
        <DMSHeader
          title={
            // view ? t('View Contact Detaiils') :
            inEdit ? t("Edit Resource Details") : t("Create Resource")
          }
          showIconsForback={true}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 14,
      id: 1,
      component: <CreateResourceRegForm inEdit={inEdit} />,
    },
  ];
  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default CreateResource;
